import { useState, useEffect } from 'react';

/**
 * Re-renders consumers every `intervalMs` so time-derived displays (e.g. the ETA countdown) stay
 * current between data updates. This is a legitimate cadence timer — not a UI timing hack to fake
 * reactivity. (In Angular this would be an observable timer.)
 */
export const useNow = (intervalMs = 30_000) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
};
